














































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class WidgetPrevious extends Vue {
  @Prop({ default: '15' }) readonly width?: string;
  @Prop({ default: '15' }) readonly height?: string;
  @Prop({ default: '#3E24D6' }) readonly color1?: string;
  @Prop({ default: '#007CEA' }) readonly color2?: string;

  id = `svg-linear-gradient-${String(Math.random())}`;
  id2 = `svg-linear-gradient-${String(Math.random())}`;
}
